module.exports = __webpack_public_path__ + "first-20_front.jpg?850d9a86e346c98c442b331e952489dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_front.jpg
// module id = 497
// module chunks = 0